<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoFlow
      :workflow-id="FlowType.ReviewPaymentAmount"
      :account-number="current.accountNumber"
      title="Review Payment Amount"
      data-testid="review-payment-amount-flow"
      @closed="flowClosed()"
    />
    <SoFlowExit
      v-model="exitWorkflowModal"
      @on-workflow-exit="exitWorkflow()"
    />
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { useReviewPaymentStore } from "@/stores/reviewPayment"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../../overview/CustomerAccountInfoRail.vue"
  import SoFlow from "@/flows/SoFlow.vue"
  import SoFlowExit from "@/flows/SoFlowExit.vue"
  import { FlowType } from "@/flows/useCases"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoFlow,
      SoFlowExit,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        reviewPayment: useReviewPaymentStore(),
        exitWorkflowModal: false,
        FlowType,
      }
    },
    mounted() {
      this.current.setSidePanelCollapsed(true)
    },
    methods: {
      flowClosed() {
        this.exitWorkflowModal = true
      },
      exitWorkflow() {
        this.exitWorkflowModal = false
        this.reviewPayment.reset()
        this.$router.push({ name: RouteNames.CustomerFinancials })
      },
    },
  })
</script>
